import {AfterViewInit, Component, OnInit} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {myFormatDate} from '../../../core/helpers/date-timer.helper';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {Router, RouterModule} from '@angular/router';
import {ShopSellerBatchService} from '../../../core/services/shop-seller/shop-seller-batch.service';
import {
  createPaginationState,
  setPaginationLoading,
  updatePaginationFromResult,
} from '../../../core/helpers/pagination-state.helper';
import {ShopSellerBatchModel} from '../../../core/models/shop-seller/shop-seller-batch.model';
import {LoadingComponent} from '../../../shared/components/loading/loading.component';
import {AlertComponent} from '../../../shared/components/alert/alert.component';
import {PaginationComponent} from '../../../shared/components/pagination/pagination.component';
import {FeatherPipe} from '../../../core/pipes/feather.pipe';

@Component({
  selector: 'app-sellers-list',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, RouterModule, LoadingComponent, AlertComponent, PaginationComponent, FeatherPipe],
  templateUrl: './shop-sellers-batch-list.component.html',
  styleUrl: './shop-sellers-batch-list.component.scss'
})
export class ShopSellersBatchListComponent implements OnInit, AfterViewInit {

  protected readonly formatDate = myFormatDate;

  error: string | null = null;

  batches: ShopSellerBatchModel[] = [];
  readonly paginationState = createPaginationState();

  constructor(
    private readonly router: Router,
    private readonly shopSellerService: ShopSellerBatchService
  ) {}

  ngOnInit(): void {
    this.onPageChange(0, this.paginationState().itemsPerPage);
  }

  ngAfterViewInit(): void {}

  onPageChange = (page: number, pageSize: number): void => {
    setPaginationLoading(this.paginationState, true);
    this.error = null;

    this.shopSellerService.getPastBatches(page, pageSize).subscribe({
      next: (result) => {
        this.batches = result.content;
        updatePaginationFromResult(this.paginationState, result, result.page.size ?? pageSize);
      },
      error: (err) => {
        this.error = 'Falha ao carregar os lotes.';
        setPaginationLoading(this.paginationState, false);
        console.error(err);
      }
    });
  }
}
